/**
 * Display a list of creators, truncated if necessary
 * @author Brendan Magee
 * <creators-list-compact creators="creators"></creators-list-compact>
 */

import template from './creatorsListCompact.html';

class CreatorsListCompactController {
  constructor() {
    this.lengthLimit = 2;
  }

  $onInit() {
    this.expandable = this.creators.length > this.lengthLimit;
    this.expanded = false;
  }
}

const creatorsListCompact = {
  template,
  bindings: {
    creators: '<'
  },
  controller: 'CreatorsListCompactController'
};

export default function (ngModule) {
  ngModule.component('creatorsListCompact', creatorsListCompact);
  ngModule.controller('CreatorsListCompactController', CreatorsListCompactController);
}
